import { FC } from 'react';
import {
  useController,
  useFormContext,
  FieldPathByValue,
} from 'react-hook-form';
import Switch from '@semcore/ui/switch';
import { StylesConfig } from '@player/content';

type FormValues = { config: StylesConfig };

type SwitchName = FieldPathByValue<FormValues, boolean>;

interface Props {
  type?: 'inline' | 'section' | 'group';
  title: string;
  name: SwitchName;
}

function getContainerClassName(type: 'inline' | 'section' | 'group') {
  switch (type) {
    case 'group':
      return 'flex grow';
    case 'section':
      return 'flex p-3';
    default:
      return 'flex h-10 grow items-center gap-2';
  }
}

function getTitleClassName(type: 'inline' | 'section' | 'group') {
  switch (type) {
    case 'group':
      return 'flex grow text-sm font-semibold';
    default:
      return 'flex grow text-base font-light leading-5';
  }
}

const SwitchSetting: FC<Props> = ({ type = 'inline', title, name }) => {
  const { control } = useFormContext<FormValues>();
  const { field } = useController<FormValues, SwitchName>({ name, control });

  return (
    <div className={getContainerClassName(type)}>
      <div className={getTitleClassName(type)}>{title}</div>

      <Switch size="l">
        <Switch.Value
          checked={Boolean(field.value)}
          onChange={field.onChange}
        />
      </Switch>
    </div>
  );
};

export default SwitchSetting;
